var map = {
	"./cases_bg.jpg": 3275,
	"./company_bg.png": 3417,
	"./engineeringCase/古青高速公路白芨滩服务区加油站装饰装修.png": 4088,
	"./engineeringCase/吴忠市红寺堡区第六幼儿园建设项目.png": 8667,
	"./engineeringCase/吴忠市红寺堡区第六幼儿园建设项目（1）.png": 5121,
	"./engineeringCase/吴忠监狱改扩建项目.png": 8961,
	"./engineeringCase/吴忠监狱改扩建项目（2）.png": 6722,
	"./engineeringCase/国网宁夏信通公司生产综合用房项目.png": 5691,
	"./engineeringCase/大武口星海镇养老护理院项目.png": 8082,
	"./engineeringCase/大武口星海镇养老护理院项目（1）.png": 546,
	"./engineeringCase/彭阳县改建第六小学（白阳镇寄宿制小学）项目.png": 4481,
	"./engineeringCase/彭阳县改建第六小学（白阳镇寄宿制小学）项目（1）.png": 1395,
	"./engineeringCase/德胜滨河路生态运动公园绿化项目.png": 5976,
	"./engineeringCase/德胜滨河路生态运动公园绿化项目（1）.png": 4756,
	"./engineeringCase/欣益巷（宣和巷-朔方路）道路工程.png": 3968,
	"./engineeringCase/苦水河（吴忠市同心县段）防洪治理工程.png": 426,
	"./engineeringCase/苦水河（吴忠市同心县段）防洪治理工程（1）.png": 5626,
	"./engineeringCase/西吉县旧城区综合治理项目.png": 9580,
	"./engineeringCase/西吉县旧城区综合治理项目（1）.png": 4448,
	"./font/ysbth.ttf": 9483,
	"./home_bottom_bg.jpg": 1825,
	"./home_fm.png": 5149,
	"./honorsAndQualifications/2017年信用A级.jpg": 1950,
	"./honorsAndQualifications/2018年优秀施工队伍.png": 8510,
	"./honorsAndQualifications/2020年石嘴山市先进会员单位.jpg": 8564,
	"./honorsAndQualifications/2021年度宁夏建筑业联合会先进会员单位.jpg": 3676,
	"./honorsAndQualifications/2021年银川市先进会员单位.jpg": 9122,
	"./honorsAndQualifications/2022年度联合会先进会员单位奖牌.jpg": 3600,
	"./honorsAndQualifications/2024.6.21全二级资质证书 - 副本.jpg": 7418,
	"./honorsAndQualifications/2024.6.21最新劳务资质证书.jpg": 7343,
	"./honorsAndQualifications/2024年6月最新三体系证书 质量管理.png": 9481,
	"./honorsAndQualifications/2024年6月最新三体系证书环境管理.png": 1116,
	"./honorsAndQualifications/2024年6月最新三体系证书职业健康.png": 5177,
	"./honorsAndQualifications/21年石嘴山先进会员单位奖牌.png": 4287,
	"./honorsAndQualifications/22年度石嘴山先进会员单位奖牌.jpg": 9166,
	"./honorsAndQualifications/22年技能大赛奖牌.jpg": 7942,
	"./honorsAndQualifications/23年技能大赛奖牌-自治区.png": 4071,
	"./honorsAndQualifications/23年技能大赛奖牌-银川市.png": 3121,
	"./honorsAndQualifications/3A奖牌.png": 1957,
	"./honorsAndQualifications/中石油HSE认证证书 (1).jpg": 518,
	"./honorsAndQualifications/压力管道资质副本.jpg": 8848,
	"./honorsAndQualifications/宁夏银行2016A+级证书.jpg": 3314,
	"./honorsAndQualifications/安防证.jpg": 5502,
	"./honorsAndQualifications/承装修试三级.png": 9304,
	"./honorsAndQualifications/林草种子电子证.jpg": 2906,
	"./honorsAndQualifications/水利3A证书.png": 239,
	"./honorsAndQualifications/自治区和谐劳动关系奖牌.jpg": 3999,
	"./honorsAndQualifications/道路运输许可证.jpg": 3272,
	"./honorsAndQualifications/银川22年度先进会员单位奖牌.jpg": 8415,
	"./honorsAndQualifications/银川市2016-2017年度守合同重信用.jpg": 5864,
	"./honorsAndQualifications/银川市农民工工资诚信支付承诺企业.jpg": 7283,
	"./honorsAndQualifications/银川市副会长单位.jpg": 5030,
	"./logo.png": 3153,
	"./map.png": 12,
	"./other/contact_logo.jpg": 7819,
	"./other/other_bg.jpg": 3601,
	"./other/other_logo.png": 850,
	"./qualification/qualification1.png": 1150,
	"./qualification/qualification10.png": 4284,
	"./qualification/qualification2.png": 8501,
	"./qualification/qualification3.png": 9404,
	"./qualification/qualification4.png": 9571,
	"./qualification/qualification5.png": 1994,
	"./qualification/qualification6.png": 2161,
	"./qualification/qualification7.png": 4296,
	"./qualification/qualification8.png": 6559,
	"./qualification/qualification9.png": 230,
	"./work_type1.jpg": 6435,
	"./work_type2.jpg": 372,
	"./work_type3.jpg": 2177,
	"./work_type4.jpg": 6946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;